import { useQuery } from '@tanstack/react-query';
import { NonScriptRangeProps } from '../interface/interface';
import Loading from './Loading';
import ProductCards from './ProductCards';
import showToast from './ToastComponent';
import { getBundledAccessories } from '../service/getBundleAccessories';
import { useAuth } from 'react-oidc-context';
import { useContext } from 'react';
import { CartContext } from '../context/cartContext';

export default function NonScriptRangeBundles(props: NonScriptRangeProps) {
  const { user } = useAuth();
  const { cart } = useContext(CartContext);
  const { data, isLoading } = useQuery({
    queryKey: ['bundled-accessories', user?.access_token, cart],
    queryFn: async () => {
      const accessories = await getBundledAccessories(user!.access_token, cart);
      if (!accessories)
        showToast({
          message: 'Unable to fetch bundled accessories!',
          type: 'info',
        });
      else return accessories;

      return [];
    },
    enabled: !!user?.access_token,
  });

  if (isLoading || props.loading) return <Loading />;

  return (
    <div className="result-block-container">
      <ul className="grid grid-cols-1 gap-6 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4">
        {data && data?.length > 0 ? (
          data?.map((product: any, index: number) => (
            <div key={index}>
              <ProductCards
                addProductToCart={async (id: string) => {
                  await props.addToCartMutation.mutateAsync(id);
                }}
                removeProductFromCart={async (productId: string) => {
                  await props.removeFromCartMutation.mutateAsync(productId);
                }}
                product={product}
                substitueCard={false}
                isAccessories={true}
                allowedProduct={false}
              />
            </div>
          ))
        ) : (
          <p>No Non-Script Range Bundled Products Exist </p>
        )}
      </ul>
    </div>
  );
}
